import ProcessesDsfr from "components/templates/processesDsfr/ProcessesDsfr";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "PROCESSESDSFR",
  label: "Toutes les démarches (DSFR)",
  Component: ProcessesDsfr,
  initialContents: [
    {
      key: "showLogo",
      type: elementsTypes.ALONE_CHECKBOX,
      value: "true",
    },
    {
      key: "dynamicList",
      type: elementsTypes.DYNAMIC_LIST,
      value: "",
      children: [
        {
          key: "limit",
          value: "2",
        },
        { key: "contentType", value: [elementsTypes.BUTTON].toString() },
      ],
    },
    {
      key: "dsfrCards",
      type: elementsTypes.DSFR_TILE_CARDS_LIST,
      value: "",
    },
  ],
};
